<template>
  <div :id="form_id">
    <div v-if="duplicate" class="alert alert-warning">
      <div>Такой турист уже есть в базе: <strong>{{ duplicate.attributes.full_name }}</strong></div>
      <b-button size="sm" variant="outline-secondary" @click="use_duplicate">
        Добавить его в заказ
      </b-button>
    </div>
    <div v-html="rawFormHTML"></div>
    <div class="text-danger">{{errors}}</div>
  </div>
</template>
<script>
  export default {
    props: {
      id: Number,
      action: String,
      order_id: [Number, String],
      role: {
        type: String,
        default: 'user',
      }
    },
    data() {
      let prefix = '';
      if (this.role === 'agent') prefix = '/agent'
      return{
        rawFormHTML: '<p>Секундочку..</p>',
        errors: '',
        duplicate: null,
        url_prefix: prefix,
      }
    },

    computed: {
      form_id() {
        return `modal_${this.action}_customer_${this.id}_form`
      },
      form_url() {
        // order_id нужен форме, чтобы показать владельца создаваемой карточки (заказ юр.лица)
        if (this.action === 'new')  { return `${this.url_prefix}/customers/new${this.order_param}`  }
        if (this.action === 'edit') { return `${this.url_prefix}/customers/${this.id}/edit` }
      },
      order_param() {
        return this.order_id ? `?order_id=${this.order_id}` : '';
      },
      data_url() {
        if (this.action === 'new')  { return `${this.url_prefix}/customers`  }
        if (this.action === 'edit') { return `${this.url_prefix}/customers/${this.id}` }
      },
      request_type() {
        if (this.action === 'new')  { return "POST"  }
        if (this.action === 'edit') { return "PATCH" }
      },
      submit_selector() {
        return `#${this.form_id} input[type="submit"]`
      },
      form_selector() {
        return `#${this.form_id} form`
      },
    },

    beforeMount() {
      let vc = this;

      $.ajax({
          url: vc.form_url,
          dataType: "json",
          type: "GET"
        })
        .done( function(data) {
          console.log('Успешно.', data);
          vc.$set(vc, 'rawFormHTML', data.html_form);
        })
        .fail( function(jqXHR, textStatus) {
          var errors = jqXHR.responseJSON;
          vc.$set(vc, 'rawFormHTML', `<p>Ошибка загрузки формы с сервера.</p><p>${errors}</p>`);
        })
    },

    updated() {
      console.log('updated.');
      let vc = this;
      $(vc.submit_selector).on('click', function(e){

        console.log('CLICK ON SUBMIT');
        e.preventDefault();
        vc.on_submit();
      });
    },

    methods:{
      on_submit () {
        var vc = this;
        $.ajax({
            url: vc.data_url,
            data: $(vc.form_selector).serialize(),
            dataType: 'json',
            type: vc.request_type,
          })
          .done( function(data) {
            console.log('Успешно.', data);
            if (data.html_form === undefined) {
              vc.$emit('submit_ok', data.data)
            } else {
              vc.$set(vc, 'duplicate', data.duplicate || null);
              vc.$set(vc, 'rawFormHTML', data.html_form);
            }
          })
          .fail( function(jqXHR, textStatus) {
            var errors = jqXHR.responseJSON;
            vc.$set(vc, 'errors', errors);
            vc.$emit('submit_error', errors);
          })
      },

      // вместо дубля в заказ добавляется найденная существующая карточка
      use_duplicate () {
        this.$emit('submit_ok', this.duplicate);
        this.$set(this, 'duplicate', null);
      }

    },
  }
</script>